{
  "es": {
    "markdownEditor": {
      "toolbar": "Formato",
      "bold": "Negrita",
      "italic": "Cursiva",
      "heading": "Encabezado",
      "bulletList": "Lista con viñetas",
      "orderedList": "Lista numerada",
      "center": "Centrar",
      "details": "Sección desplegable",
      "detailsCollapse": "Contraer la sección",
      "detailsExpand": "Desplegar la sección",
      "link": "Enlace",
      "linkUrl": "Dirección del enlace",
      "linkUrlPlaceholder": "https://…",
      "linkApply": "Aplicar",
      "linkRemove": "Quitar enlace",
      "linkInvalid": "Solo se pueden enlazar direcciones http(s) o rutas de este sitio.",
      "image": "Imagen",
      "imageAlt": "Descripción de la imagen",
      "imageApply": "Insertar",
      "close": "Cerrar",
      "source": "Editar el código Markdown",
      "imageUploadFailed": "No se pudo subir la imagen. Inténtalo de nuevo.",
      "imageTitle": "Insertar una imagen",
      "imageAltHint": "Se lee en lugar de la imagen y se muestra si no puede cargarse.",
      "cancel": "Cancelar",
      "imageSize": "Tamaño de la imagen",
      "imageSize25": "Pequeña",
      "imageSize50": "Mediana",
      "imageSize75": "Grande",
      "imageSizeFull": "Ancho completo",
      "item": "Artículo del catálogo",
      "itemSearchHint": "Escribe el nombre de un artículo",
      "itemSearchEmpty": "Ningún artículo listado con ese nombre",
      "itemType": {
        "Component": "Componente",
        "Equipment": "Equipo",
        "Commodity": "Mercancía",
        "Model": "Nave",
        "Blueprint": "Plano",
        "GameMission": "Misión",
        "Location": "Lugar",
        "FleetContract": "Contrato",
        "FleetEvent": "Evento",
        "User": "Usuario"
      }
    }
  }
}
